import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant";
import { const_var, params } from "../../../redux/reducers/reducer";
import { convertToTwoDecimalNumber } from "../../../redux/reducers/utils";

export const trussDimensions = (isFor) => {
	let roofPitch = params.p_r_p;
	let buildingWidth = params.p_w;
	let buildingHeight = params.p_h;
	let trussRotation = 0;

	switch (isFor) {
		case "gableFrontLean":
			roofPitch = params.b_l_t_r_pF;
			buildingWidth = params.leanF_p_w;
			buildingHeight = params.leanF_p_h;
			trussRotation = Math.PI;
			break;
		case "gableBackLean":
			roofPitch = params.b_l_t_r_pB;
			buildingWidth = params.leanB_p_w;
			buildingHeight = params.leanB_p_h;
			trussRotation = 0;
			break;
		case "gableLeftLean":
			roofPitch = params.b_l_t_r_p;
			buildingWidth = params.lean_p_w;
			buildingHeight = params.lean_p_h;
			trussRotation = Math.PI / 2;
			break;
		case "gableRightLean":
			roofPitch = params.b_l_t_r_pR;
			buildingWidth = params.leanR_p_w;
			buildingHeight = params.leanR_p_h;
			trussRotation = Math.PI / 2;
			break;
		default:
			roofPitch = params.p_r_p;
			buildingWidth = params.p_w;
			buildingHeight = params.p_h;
			trussRotation = 0;
			break;
	}

	return { roofPitch, buildingWidth, buildingHeight, trussRotation };
};
export const trussCalcuate = (filterData, postData, tCost, customParams, customTotalPriceWithoutAdditionalItem, customLeantoPriceCalculation, from, iiD) => {
	let standardTrussLabel = "Standard Truss";
	if (customParams.m_s_n == 153 && customParams.p_r_s == 3) {
		standardTrussLabel = "Vertical Truss";
	}
	const a_p_d_a = const_var.isLTBuilding ? JSON.parse(JSON.stringify(const_var.holdPricingResponse)) : const_var.a_p_d_a;
	const hasFilterData = filterData?.length > 0;
	const building = postData["building"];
	if (!hasFilterData) return 0;
	if (from != "compare") {
		const otherTrusses = a_p_d_a.truss_name.filter((item, index) => {
			if (item.is_default != undefined && params.p_w <= item.max_width && params.p_w >= item.min_width && !item.name.includes(building?.edit_truss_name)) {
				return true;
			}
		});

		if (params.m_s_n == 153 && filterData[0]?.is_default == true && filterData?.[0].label.toLowerCase().includes("premier")) {
			building.truss_type_name = "Premier Truss";
		} else {
			building.truss_type_name =
				filterData[0]?.is_default == true || otherTrusses.length == 0
					? otherTrusses.length == 0
						? filterData?.[0]?.is_default == true && filterData?.[0]?.is_show == true && filterData?.[0]?.label
							? filterData?.[0]?.label
							: ""
						: standardTrussLabel
					: customParams.m_s_n == 153
						? (filterData?.[0]?.label ?? "Ladder Truss")
						: (filterData?.[0]?.label ?? "High Truss");
		}
	}

	if (hasFilterData) {
		let finalCost = 0;
		let priceData = filterData[0];
		if (priceData.price_type == "%" && filterData?.[0]?.price_of && filterData?.[0]?.cost) {
			let splval = 0;
			if (priceData.price_of.includes("full_building_price") !== false) {
				splval =
					parseFloat(splval) +
					(customTotalPriceWithoutAdditionalItem ? parseFloat(customTotalPriceWithoutAdditionalItem) : 0) +
					(customLeantoPriceCalculation.totalLeanPrice ? parseFloat(customLeantoPriceCalculation.totalLeanPrice) : 0);
			}
			if (priceData.price_of.includes("base_price") != false) {
				splval = parseFloat(splval) + (building.roof_style_price ? parseFloat(building.roof_style_price) : 0);
			}
			if (priceData.price_of.includes("wall_price") != false) {
				if (customParams.p_u_c == true || customParams.cB_addStorage_check_left == true || customParams.cB_addStorage_check_right == true) {
					splval =
						parseFloat(splval) +
						parseFloat(building.utility_price) +
						parseFloat(building.front_wall_price) +
						parseFloat(building.left_wall_price) +
						parseFloat(building.right_wall_price) +
						parseFloat(building.back_wall_price) +
						parseFloat(customLeantoPriceCalculation.totalWallPrice);
				} else {
					splval =
						parseFloat(splval) +
						parseFloat(building.front_wall_price) +
						parseFloat(building.left_wall_price) +
						parseFloat(building.right_wall_price) +
						parseFloat(building.back_wall_price) +
						parseFloat(customLeantoPriceCalculation.totalWallPrice);
				}
				if (building.utility_front_price != undefined && customParams.isBreezeway && customParams.cB_addStorage_check_front) {
					splval = parseFloat(splval) + parseFloat(building.utility_front_price);
				}
			}
			if (priceData.price_of.includes("height_price") != false) {
				splval = parseFloat(splval) + parseFloat(building.height_price) + parseFloat(customLeantoPriceCalculation.totalHeightPrice);
			}
			finalCost = (splval * priceData.cost) / 100;
		} else if (priceData.price_type == "sqft" && filterData.length > 0 && filterData[0].price_of != null && filterData[0].price_of != undefined && filterData[0].cost !== undefined && filterData[0].cost) {
			finalCost = 0;
		} else {
			finalCost = priceData.cost;
		}
		if (from == "compare") {
			const edit_truss_name =
				const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");
			const otherTrusses = const_var.ComparisionDataArray[iiD].pricing_data.truss_name.filter((item, index) => {
				if (item.is_default != undefined && params.p_w <= item.max_width && params.p_w >= item.min_width && !item.name.includes(edit_truss_name)) {
					return true;
				}
			});
			if (customParams.m_s_n == 153 && filterData[0]?.is_default == true && filterData[0].label != null && filterData[0].label != undefined && filterData[0].label.toLowerCase().includes("premier")) {
				building.truss_type_name = "Premier Truss";
			} else {
				building.truss_type_name =
					filterData[0]?.is_default == true || otherTrusses.length == 0 ? standardTrussLabel : customParams.m_s_n == 153 ? (filterData?.[0]?.label ?? "Ladder Truss") : (filterData?.[0]?.label ?? "High Truss");
			}
			postData.building.truss_price = convertToTwoDecimalNumber(finalCost);
			const trussType = filterData?.[0]?.name?.replace(/[0-9]/g, "");
			postData.building.trussType = trussType;
			customParams.trussType = trussType;
			customParams.newtrussType = trussType;
			tCost = parseFloat(tCost) + (postData.building.truss_price ? convertToTwoDecimalNumber(postData.building.truss_price) : 0);
		} else {
			building.truss_price = const_var.UpdatedPriceData.truss_price_changed != true ? (const_var.UpdatedPriceData.truss_price ? const_var.UpdatedPriceData.truss_price : 0) : convertToTwoDecimalNumber(finalCost);
			tCost = parseFloat(tCost) + (building.truss_price ? parseFloat(building.truss_price) : 0);
		}
	} else if (from != "compare") {
		building.truss_price = convertToTwoDecimalNumber(const_var.UpdatedPriceData.truss_price_changed != true ? (const_var.UpdatedPriceData.truss_price ? const_var.UpdatedPriceData.truss_price : 0) : 0);
		tCost = parseFloat(tCost) + (building.truss_price ? parseFloat(building.truss_price) : 0);
	}
	return tCost;
};
export const updateTrussId = (leanType, state, newPricingData) => {
	params.l_t_p[leanType].trussId = null;
	state.params.l_t_p[leanType].trussId = null;
};

export const trussCalcuateForGableLean = (params, t_c_withoutAdditionalItem, b, LeanData, UpdatePriceRecord) => {
	const leanType = LEAN_TYPE_NUM_TO_STR[b.leanto_type];
	let leanWidth = null,
		leanData = null;

	if (leanType == "left") {
		leanWidth = params.lean_p_w;
		leanData = const_var.leanGetDataLeft;
	}
	if (leanType == "right") {
		leanWidth = params.leanR_p_w;
		leanData = const_var.leanGetDataRight;
	}
	if (leanType == "front") {
		leanWidth = params.leanF_p_w;
		leanData = const_var.leanGetDataFront;
	}
	if (leanType == "back") {
		leanWidth = params.leanB_p_w;
		leanData = const_var.leanGetDataBack;
	}

	let filterData = null;

	const eligbleTrusses = leanData?.truss_name?.filter((truss) => leanWidth <= truss.max_width && leanWidth >= truss.min_width);

	if (params.l_t_p[leanType].trussId) {
		filterData = eligbleTrusses?.find((truss) => truss.id == params.l_t_p[leanType].trussId);
	} else {
		filterData = eligbleTrusses?.find((truss) => truss.is_default === 1);

		if (!filterData) {
			filterData = eligbleTrusses?.[0];
		}

		if (filterData) {
			b.truss = filterData;
			params.l_t_p[leanType].truss = filterData;
			params.l_t_p[leanType].trussName = filterData?.name?.replace(/[0-9]/g, "");
			params.l_t_p[leanType].trussId = filterData.id;
		}
	}

	if (filterData?.trussId) {
		return;
	}

	if (filterData) {
		b.truss = filterData;
	}

	let tCost = 0;

	let standardTrussLabel = "Standard Truss";
	if (params.m_s_n == 153 && params.p_r_s == 3) {
		standardTrussLabel = "Vertical Truss";
	}

	if (filterData) {
		const otherTrusses = leanData.truss_name.filter((item) => {
			if (item.is_default != undefined && leanWidth <= item.max_width && leanWidth >= item.min_width && !item.name.includes(b.edit_truss_name)) {
				return true;
			}
		});

		if (params.m_s_n == 153 && filterData.is_default && filterData.label != undefined && filterData.label.toLowerCase().includes("premier")) {
			b.truss_type_name = "Premier Truss";
		} else {
			if (filterData.is_default || !otherTrusses.length) {
				if (!otherTrusses.length) {
					if (filterData.is_default && filterData.is_show && filterData.label != undefined) {
						b.truss_type_name = filterData.label;
					} else {
						b.truss_type_name = "";
					}
				} else {
					b.truss_type_name = standardTrussLabel;
				}
			} else {
				if (params.m_s_n == 153) {
					if (filterData.label != undefined) {
						b.truss_type_name = filterData.label;
					} else {
						b.truss_type_name = "Ladder Truss";
					}
				} else {
					if (filterData?.label != undefined) {
						b.truss_type_name = filterData.label;
					} else {
						b.truss_type_name = "High Truss";
					}
				}
			}
		}
	}

	if (!filterData) {
		tCost += b.truss_price;
		return tCost;
	}

	if (filterData) {
		let finalCost = 0;

		if (filterData.price_type == "%" && filterData.price_of != undefined && filterData.cost !== undefined && filterData.cost) {
			let p = 0;
			if (filterData.price_of.includes("full_building_price")) {
				p += t_c_withoutAdditionalItem ? parseFloat(t_c_withoutAdditionalItem) : 0;
			}
			if (filterData.price_of.includes("base_price")) {
				p += b.basic_price ? parseFloat(b.basic_price) : 0;
			}
			if (filterData.price_of.includes("wall_price")) {
				p += parseFloat(b.front_wall_price ?? 0) + parseFloat(b.side_wall_price ?? 0) + parseFloat(b.left_wall_price ?? 0) + parseFloat(b.right_wall_price ?? 0) + parseFloat(b.back_wall_price ?? 0);

				if (b.utility_price && parseFloat(b.utility_price) > 0) {
					p += parseFloat(b.utility_price);
				}

				if (b.utility_front_price && parseFloat(b.utility_front_price) > 0) {
					p += parseFloat(b.utility_front_price);
				}
			}
			if (filterData.price_of.includes("height_price")) {
				p += parseFloat(b.height_price);
			}
			finalCost = (p * filterData.cost) / 100;
		}
		// type sqft
		else if (filterData.price_type == "sqft" && filterData.price_of != undefined && filterData.cost !== undefined && filterData.cost) {
			finalCost = 0;
		}
		// type $$$ (doller)
		else {
			finalCost = filterData.cost;
		}

		b.truss_price = UpdatePriceRecord == true && const_var.UpdatedPriceData[`${leanType}Lean_truss_price_changed`] != true ? LeanData.truss_price : finalCost;
		tCost += convertToTwoDecimalNumber(b.truss_price) ?? 0;
		return tCost;
	}
};
